import ReadyGif from '../../containers/home/ReadyGif';

export default ReadyGif;